// Re-export the shared ProductList component for seller
import ProductList from "../Admin/ProductList";

export default function SellerProductList() {
    return <ProductList role="seller" />;
}

